import { History } from "history";

import {
  ADD_LECTURE,
  ADD_LECTURE_ERROR,
  ADD_LECTURE_SUCCESS,
  AddLectureAction,
  AddLectureErrorAction,
  AddLectureSuccessAction,
  DELETE_LECTURE,
  DELETE_LECTURE_CONSENT,
  DELETE_LECTURE_ERROR,
  DELETE_LECTURE_SUCCESS,
  DeleteLectureAction,
  DeleteLectureConsentAction,
  DeleteLectureErrorAction,
  DeleteLectureSuccessAction,
  GET_LECTURE,
  GET_LECTURES,
  GET_LECTURES_BY_LESSON,
  GET_LECTURES_BY_LESSON_ERROR,
  GET_LECTURES_BY_LESSON_SUCCESS,
  GET_LECTURES_BY_SUBJECT,
  GET_LECTURES_BY_SUBJECT_ERROR,
  GET_LECTURES_BY_SUBJECT_SUCCESS,
  GET_LECTURES_ERROR,
  GET_LECTURES_SUCCESS,
  GET_LECTURE_ERROR,
  GET_LECTURE_SUCCESS,
  GetLectureAction,
  GetLectureErrorAction,
  GetLectureSuccessAction,
  GetLecturesAction,
  GetLecturesByLessonAction,
  GetLecturesByLessonErrorAction,
  GetLecturesByLessonSuccessAction,
  GetLecturesBySubjectAction,
  GetLecturesBySubjectErrorAction,
  GetLecturesBySubjectSuccessAction,
  GetLecturesErrorAction,
  GetLecturesSuccessAction,
  TOGGLE_ADD_EDIT_LECTURE_MODAL,
  TOGGLE_LECTURE_STATE,
  TOGGLE_LECTURE_STATE_CONSENT,
  TOGGLE_LECTURE_STATE_ERROR,
  TOGGLE_LECTURE_STATE_SUCCESS,
  ToggleAddEditLectureModalAction,
  ToggleLectureStateAction,
  ToggleLectureStateConsentAction,
  ToggleLectureStateErrorAction,
  ToggleLectureStateSuccessAction,
  UPDATE_LECTURE,
  UPDATE_LECTURE_ERROR,
  UPDATE_LECTURE_SUCCESS,
  UPLOAD_LECTURE_VIDEO,
  UPLOAD_LECTURE_VIDEO_ERROR,
  UPLOAD_LECTURE_VIDEO_PROGRESS,
  UPLOAD_LECTURE_VIDEO_SUCCESS,
  UpdateLectureAction,
  UpdateLectureErrorAction,
  UpdateLectureSuccessAction,
  UploadLectureVideoAction,
  UploadLectureVideoErrorAction,
  UploadLectureVideoProgressAction,
  UploadLectureVideoSuccessAction,
} from "./actionTypes";
import {
  CreateLectureRequest,
  LectureDto,
  PaginateQuery,
  UpdateLectureRequest,
} from "../../interfaces";
import { Paginated } from "../../models";
import { MediaDto } from "../../interfaces/media";

//#region Get Lectures

export const getLectures = (
  request: PaginateQuery,
  history: History
): GetLecturesAction => {
  return {
    type: GET_LECTURES,
    payload: { request, history },
  };
};

export const getLecturesSuccess = (
  response: Paginated<LectureDto>
): GetLecturesSuccessAction => {
  return {
    type: GET_LECTURES_SUCCESS,
    payload: response,
  };
};

export const getLecturesError = (error: any): GetLecturesErrorAction => {
  return {
    type: GET_LECTURES_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Lectures by Lesson Id

export const getLecturesByLesson = (
  lessonId: string,
  history: History
): GetLecturesByLessonAction => {
  return {
    type: GET_LECTURES_BY_LESSON,
    payload: { lessonId, history },
  };
};

export const getLecturesByLessonSuccess = (
  response: LectureDto[]
): GetLecturesByLessonSuccessAction => {
  return {
    type: GET_LECTURES_BY_LESSON_SUCCESS,
    payload: response,
  };
};

export const getLecturesByLessonError = (
  error: any
): GetLecturesByLessonErrorAction => {
  return {
    type: GET_LECTURES_BY_LESSON_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Lectures by Subject Id

export const getLecturesBySubject = (
  subjectId: string,
  history: History
): GetLecturesBySubjectAction => {
  return {
    type: GET_LECTURES_BY_SUBJECT,
    payload: { subjectId, history },
  };
};

export const getLecturesBySubjectSuccess = (
  response: LectureDto[]
): GetLecturesBySubjectSuccessAction => {
  return {
    type: GET_LECTURES_BY_SUBJECT_SUCCESS,
    payload: response,
  };
};

export const getLecturesBySubjectError = (
  error: any
): GetLecturesBySubjectErrorAction => {
  return {
    type: GET_LECTURES_BY_SUBJECT_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Lecture

export const getLecture = (id: string, history: History): GetLectureAction => {
  return {
    type: GET_LECTURE,
    payload: { id, history },
  };
};

export const getLectureSuccess = (
  response: LectureDto
): GetLectureSuccessAction => {
  return {
    type: GET_LECTURE_SUCCESS,
    payload: response,
  };
};

export const getLectureError = (error: any): GetLectureErrorAction => {
  return {
    type: GET_LECTURE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Lecture

export const addLecture = (
  request: CreateLectureRequest,
  history: History
): AddLectureAction => {
  return {
    type: ADD_LECTURE,
    payload: { request, history },
  };
};

export const addLectureSuccess = (
  lecture: LectureDto
): AddLectureSuccessAction => {
  return {
    type: ADD_LECTURE_SUCCESS,
    payload: lecture,
  };
};

export const addLectureError = (error: any): AddLectureErrorAction => {
  return {
    type: ADD_LECTURE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Lecture

export const updateLecture = (
  id: string,
  request: UpdateLectureRequest,
  history: History
): UpdateLectureAction => {
  return {
    type: UPDATE_LECTURE,
    payload: { id, request, history },
  };
};

export const updateLectureSuccess = (
  lecture: LectureDto
): UpdateLectureSuccessAction => {
  return {
    type: UPDATE_LECTURE_SUCCESS,
    payload: lecture,
  };
};

export const updateLectureError = (error: any): UpdateLectureErrorAction => {
  return {
    type: UPDATE_LECTURE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Lecture

export const deleteLectureConsent = (
  id: string
): DeleteLectureConsentAction => {
  return {
    type: DELETE_LECTURE_CONSENT,
    payload: id,
  };
};

export const deleteLecture = (
  id: string,
  history: History
): DeleteLectureAction => {
  return {
    type: DELETE_LECTURE,
    payload: { id, history },
  };
};

export const deleteLectureSuccess = (
  id: string
): DeleteLectureSuccessAction => {
  return {
    type: DELETE_LECTURE_SUCCESS,
    payload: id,
  };
};

export const deleteLectureError = (error: any): DeleteLectureErrorAction => {
  return {
    type: DELETE_LECTURE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Lecture Video

export const uploadLectureVideo = (
  file: File,
  history: History,
  lectureId?: string
): UploadLectureVideoAction => {
  return {
    type: UPLOAD_LECTURE_VIDEO,
    payload: { file, history, lectureId },
  };
};

export const uploadLectureVideoSuccess = (
  media: MediaDto
): UploadLectureVideoSuccessAction => {
  return {
    type: UPLOAD_LECTURE_VIDEO_SUCCESS,
    payload: media,
  };
};

export const uploadLectureVideoError = (
  error: any
): UploadLectureVideoErrorAction => {
  return {
    type: UPLOAD_LECTURE_VIDEO_ERROR,
    payload: error,
  };
};

export const uploadLectureVideoProgress = (
  progress: number
): UploadLectureVideoProgressAction => {
  return {
    type: UPLOAD_LECTURE_VIDEO_PROGRESS,
    payload: progress,
  };
};

//#endregion

//#region add edit lecture modal
export const toggleAddEditLectureModal =
  (): ToggleAddEditLectureModalAction => {
    return {
      type: TOGGLE_ADD_EDIT_LECTURE_MODAL,
      payload: null,
    };
  };
//#endregion

//#region Toggle Lecture State

export const toggleLectureStateConsent = (
  id: string
): ToggleLectureStateConsentAction => {
  return {
    type: TOGGLE_LECTURE_STATE_CONSENT,
    payload: id,
  };
};

export const toggleLectureState = (
  id: string,
  history: History
): ToggleLectureStateAction => {
  return {
    type: TOGGLE_LECTURE_STATE,
    payload: { id, history },
  };
};

export const toggleLectureStateSuccess = (
  id: string
): ToggleLectureStateSuccessAction => {
  return {
    type: TOGGLE_LECTURE_STATE_SUCCESS,
    payload: { id },
  };
};

export const toggleLectureStateError = (
  error: any
): ToggleLectureStateErrorAction => {
  return {
    type: TOGGLE_LECTURE_STATE_ERROR,
    payload: error,
  };
};

//#endregion
